import React, {useState, useEffect} from 'react'
import VerReglas from './VerReglas'
import SubirEditReglas from './SubirEditReglas'
import Eliminar  from '../componentes/Eliminar'
import Header from '../componentes/Header';
import useTraeDatos from '../hooks/useTraeDatos';
import {Titulos, peticionDelete} from '../hooks/Funciones'

const ReglasdeEnvio = ({baseUrl, titulo}) => {

	const [tituloPag, setTituloPag] = useState(titulo)
	const [registroSelect, setRegistroSelect] = useState({})
	const [funcion, setFuncion] = useState('ver')
	const [reglas, setReglas] = useTraeDatos(baseUrl)
	const [copiaReglas] = useTraeDatos(baseUrl)
	const [busqueda, setBusqueda] = useState('')
	const TitulosPagina = ['Ver reglas', 'Crear Regla', 'Editar Regla', 'Eliminar Regla', 'Reglas']

	const seleccionaRegistro = (dato, funcion) => e =>{
		setRegistroSelect({...dato, imagePrev: dato.imagen})
		setFuncion(funcion === 'eliminar' ? 'eliminar' : 'editar')
	}

	const RecibeBusqueda = e => {
		setBusqueda(e.target.value)
		filtrar(e.target.value)
	}

	const filtrar = (termino) => {
		let resultado = copiaReglas.filter((item) => {
			if(item.nombre.toLowerCase().includes(termino.toLowerCase())){
				return item
			} 
		})
		setReglas(resultado)
	}

	const peticionDeletee = () =>{peticionDelete(registroSelect, baseUrl, reglas, setReglas, setFuncion)}
	useEffect(() => {Titulos (funcion, setTituloPag, TitulosPagina)},[funcion])

	const ReiniciarPaginacion = () => {
		setReglas(copiaReglas)
		setBusqueda('')
	}

	return(
		<div>
			<Header 
				titulo={tituloPag} 
				funcion={funcion} 
				setFuncion={setFuncion} 
				Pagina={'Cursos'} 
				RecibeBusqueda={RecibeBusqueda} 
				busqueda={busqueda}
				resetBusq={ReiniciarPaginacion}
			/>
            {funcion === 'crear' ?
                <SubirEditReglas
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={reglas} 
					setData={setReglas}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					funcion={funcion}/>

			:null}
			{funcion === 'editar' ?
				<SubirEditReglas
					baseUrl={baseUrl} 
					setFuncion={setFuncion}
					data={reglas} 
					setData={setReglas}
					TituloBtn={tituloPag}
					setTituloPag={setTituloPag} 
					registroSelect={registroSelect}
					funcion={funcion}/>
			:null}
			{funcion === 'ver' ?
				<VerReglas
					data={reglas} 
					seleccionaRegistro={seleccionaRegistro}
					baseUrl={baseUrl}
				/>
			:null}
			{funcion === 'eliminar' ?
				<Eliminar 
					nombre={'Operador'}
					select={registroSelect}
					setFuncion={setFuncion}
					peticionDelete={peticionDeletee}/>
				
			:null}
		</div>
	)
}

export default ReglasdeEnvio